import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Share = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 18C21.244 18 19.697 18.911 18.805 20.284L15.412 18.588C15.788 17.804 16 16.926 16 16C16 15.074 15.789 14.196 15.412 13.412L18.805 11.716C19.697 13.089 21.244 14 23 14C25.757 14 28 11.757 28 9C28 6.243 25.757 4 23 4C20.243 4 18 6.243 18 9C18 9.288 18.026 9.57 18.073 9.845L14.242 11.76C13.156 10.673 11.655 9.999 10 9.999C6.691 9.999 4 12.69 4 15.999C4 19.308 6.691 21.999 10 21.999C11.655 21.999 13.156 21.325 14.242 20.238L18.073 22.153C18.026 22.428 18 22.71 18 22.999C18 25.756 20.243 27.999 23 27.999C25.757 27.999 28 25.756 28 22.999C28 20.242 25.757 17.999 23 17.999V18ZM23 6C24.654 6 26 7.346 26 9C26 10.654 24.654 12 23 12C21.346 12 20 10.654 20 9C20 7.346 21.346 6 23 6ZM10 20C7.794 20 6 18.206 6 16C6 13.794 7.794 12 10 12C12.206 12 14 13.794 14 16C14 18.206 12.206 20 10 20ZM23 26C21.346 26 20 24.654 20 23C20 21.346 21.346 20 23 20C24.654 20 26 21.346 26 23C26 24.654 24.654 26 23 26Z" />
	</svg>
);

export default Share;
